// extracted by mini-css-extract-plugin
export default {"overlay":"bz-z","bodyOpen":"cz-z","content":"dz-z","header":"ez-z","close":"fz-z","closeNoHeading":"gz-z"};